import { CardLayout } from '../../../sdk/@types/Revisao';

/**
 * As quatro formas de autorar um cartão no compositor (design, Decisão 9).
 * Texto, imagem e lista são jeitos de preencher um `basic`; só oclusão grava
 * `occlusion`. Nenhum valor novo entra em `CardLayout`. Imagem e lista não
 * sobrevivem na gravação — reabrir um `basic` volta em texto.
 */
export type FormaAutoria = 'texto' | 'imagem' | 'lista' | 'oclusao';

export interface TelhaAutoria {
  id: FormaAutoria;
  nome: string;
  descricao: string;
}

export const TELHAS_AUTORIA: readonly TelhaAutoria[] = [
  {
    id: 'texto',
    nome: 'Texto',
    descricao: 'Pergunta na frente e resposta no verso.',
  },
  {
    id: 'imagem',
    nome: 'Imagem',
    descricao: 'Uma imagem na frente, com o texto que a explica.',
  },
  {
    id: 'lista',
    nome: 'Lista',
    descricao: 'Um enunciado na frente e uma lista de itens no verso.',
  },
  {
    id: 'oclusao',
    nome: 'Oclusão',
    descricao: 'Marcações sobre uma imagem, cada uma perguntada na revisão.',
  },
];

export interface RotulosDaFace {
  front: string;
  back: string;
  backHint?: string;
}

/** O que cada telha pede nos dois campos `string`. Oclusão não usa esses campos. */
export function rotulosDaForma(forma: FormaAutoria): RotulosDaFace | null {
  switch (forma) {
    case 'texto':
      return { front: 'Frente (a pergunta)', back: 'Verso (a resposta)' };
    case 'imagem':
      return {
        front: 'Frente (a imagem)',
        back: 'Verso (o que a imagem mostra)',
        backHint: 'Escolha, arraste ou cole o arquivo da imagem.',
      };
    case 'lista':
      return {
        front: 'Frente (o enunciado)',
        back: 'Verso (os itens)',
        backHint: 'Cada linha que começa com “- ” é um item da lista.',
      };
    case 'oclusao':
      return null;
  }
}

/** Texto, imagem e lista gravam `basic`. Oclusão grava `occlusion`. */
export function layoutDaForma(forma: FormaAutoria): CardLayout {
  return forma === 'oclusao' ? 'occlusion' : 'basic';
}

/**
 * A forma não é um campo da API. Um cartão `occlusion` reabre em oclusão;
 * qualquer outro layout reabre em texto.
 */
export function formaInicial(layout: CardLayout | undefined): FormaAutoria {
  return layout === 'occlusion' ? 'oclusao' : 'texto';
}
